module.exports = __webpack_public_path__ + "static/img/a-4.8524bbe3.png";